import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

const API = "https://simplix.co.za/api";

export default function VerifyPasswordChange() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | success | error
  const [msg, setMsg] = useState("");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return; // guard against StrictMode double-fire
    started.current = true;

    if (!token) {
      setState("error");
      setMsg("Missing token. Please request a new password change.");
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/verify-password-change`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
          setState("error");
          setMsg(data.message || data.error || "Verification failed.");
          return;
        }

        setState("success");
        setMsg(data.message || "Password updated.");
      } catch {
        setState("error");
        setMsg("Network error. Please try again.");
      }
    })();
  }, [token]);

  if (state === "loading") {
    return (
      <div style={{ textAlign: "center", padding: "3rem" }}>
        <p>Verifying your password change…</p>
      </div>
    );
  }

  if (state === "success") {
    return (
      <div style={{ textAlign: "center", padding: "3rem" }}>
        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✅</div>
        <h2>Password updated</h2>
        <p>{msg}</p>
        <a
          href="/#/login"
          style={{
            display: "inline-block",
            marginTop: "1rem",
            padding: "10px 24px",
            background: "#0066cc",
            color: "#fff",
            borderRadius: 4,
            textDecoration: "none",
          }}
        >
          Log in with new password
        </a>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: "3rem" }}>
      <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>❌</div>
      <h2>Verification failed</h2>
      <p>{msg}</p>
      <a
        href="/#/change-password"
        style={{
          display: "inline-block",
          marginTop: "1rem",
          padding: "10px 24px",
          background: "#555",
          color: "#fff",
          borderRadius: 4,
          textDecoration: "none",
        }}
      >
        Request again
      </a>
    </div>
  );
}